let institute = [
    {
        path: '/institute/instituteclassify',
        name: 'instituteclassify',
        component: () => import('@/views/institute/instituteclassify.vue'),
        meta: {keepAlive: true, parentPath: 'institute'},
    },
    {
        path: '/institute/tags',
        name: 'tags',
        component: () => import('@/views/institute/tags.vue'),
        meta: {keepAlive: true, parentPath: 'institute'},
    },
    {
        path: '/institute/institutebase',
        name: 'institutebase',
        component: () => import('@/views/institute/institutebase/list.vue'),
        meta: {keepAlive: true, parentPath: 'institute'},
    },
    {
        path: '/institute/institutebase/edit',
        name: 'edit',
        component: () => import('@/views/institute/institutebase/edit.vue'),
        meta: {keepAlive: true, parentPath: 'institute'},
    }
    ,
    {
        path: '/institute/institutebase/translation',
        name: 'translation',
        component: () => import('@/views/institute/institutebase/translation.vue'),
        meta: {keepAlive: true, parentPath: 'institute'},
    }
    
]
export default institute


// WEBPACK FOOTER //
// ./src/router/institute.js